import React, { useState, useEffect, Fragment } from 'react';
import IntlMessages from '../../../../helpers/IntlMessages';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './table.scss';
import moment from 'moment';

export default function AriDatePicker({ getStartDate, handleRoomDataLoad }) {
  // ✅ Use native Date, not moment()
  const [startDate, setStartDate] = useState(new Date());
  const [daysArr, setDaysArr] = useState([]);

  const daysArrGenerator = (start, stop) => {
    let arr = [];
    while (start < stop) {
      arr.push(moment(start));
      start = moment(start).add(1, 'days').toDate(); // ✅ keep it as Date
    }
    return arr;
  };

  useEffect(() => {
    setDaysArr(
      daysArrGenerator(
        startDate,
        moment(startDate).add(5, 'days').toDate()
      )
    );
    handleRoomDataLoad(moment(startDate), moment(startDate).add(5, 'days'));
  }, [startDate]);

  const handldDateChange = (date) => {
    setStartDate(date); // ✅ date is a native Date
    getStartDate(moment(date)); // pass moment if needed
  };

  const moveDays = (e, direction) => {
    e.preventDefault();
    let date = startDate;
    if (direction === 'left') {
      const newStart = moment(date).subtract(5, 'days').toDate();
      setStartDate(newStart);
      handleRoomDataLoad(moment(newStart), moment(date));
    }
    if (direction === 'right') {
      const newStart = moment(date).add(5, 'days').toDate();
      setStartDate(newStart);
      handleRoomDataLoad(moment(date), moment(newStart));
    }
  };

  return (
    <Fragment>
      <div className="fix">-</div>
      <div className="top">
        <div className="date-picker">
          <div className="form-group has-float-label">
            <DatePicker
              selected={startDate} //  must be Date
              onChange={handldDateChange}
              dateFormat="dd/MM/yyyy" //  correct format
              placeholderText="Select date"
            />
            <IntlMessages id="forms.date" />
          </div>
        </div>
        <div className="date-chevron">
          <FontAwesomeIcon
            icon={faChevronLeft}
            onClick={(e) => moveDays(e, 'left')}
          />
        </div>
        <div className="date-chevron">
          <FontAwesomeIcon
            icon={faChevronRight}
            onClick={(e) => moveDays(e, 'right')}
          />
        </div>
        <div className="date-list">
          <div className="date-blank" style={{ visibility: 'hidden' }}>x</div>
          {daysArr.map((day, index) => (
            <Fragment key={index}>
              {day.format('ddd') === 'Sat' || day.format('ddd') === 'Sun' ? (
                <div className="date-cell-gray">
                  <div>
                    {day.format('DD MMM')} <b>({day.format('ddd')[0]})</b>
                  </div>
                </div>
              ) : (
                <div className="date-cell">
                  <div>
                    {day.format('DD MMM')} <b>({day.format('ddd')[0]})</b>
                  </div>
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </Fragment>
  );
}
